// src/hooks/useRealtimeI18n.js
import { useEffect } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { db } from "../firebase/firebaseConfig";
import { loadI18nResource } from "../i18n";

export function useRealtimeI18n(lang) {
  useEffect(() => {
    const unsub = onSnapshot(doc(db, "i18n", lang), (snap) => {
      if (snap.exists()) {
        const data = snap.data();
        const cache = localStorage.getItem("i18n_cache_" + lang);
        let cacheVersion = null;
        if (cache) {
          try {
            cacheVersion = JSON.parse(cache).version;
          } catch {}
        }
        if (data.version && data.version !== cacheVersion) {
          // Xóa cache, nạp bản dịch mới nhất
          localStorage.removeItem("i18n_cache_" + lang);
          loadI18nResource(lang);
        }
      }
    });
    return () => unsub();
  }, [lang]);
}
